import { BASE_URL, REFERRALS_CLICK, REFERRALS_VALIDATE } from "./apis";

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function isValidReferralPayload(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (payload.valid === true || payload.success === true || payload.status === true) {
    return true;
  }
  if (payload.valid === false || payload.success === false || payload.status === false) {
    return false;
  }
  if (payload.data && typeof payload.data === "object") {
    if (payload.data.valid === false) return false;
    return true;
  }
  return false;
}

export async function validateReferralCode(code) {
  const response = await fetch(
    `${BASE_URL}${REFERRALS_VALIDATE}/${encodeURIComponent(code)}`,
    { method: "GET", headers: { Accept: "application/json" } },
  );

  const contentType = response.headers.get("content-type") || "";
  if (!response.ok || !contentType.includes("application/json")) {
    return { valid: false, data: null };
  }

  const payload = await response.json();
  return {
    valid: isValidReferralPayload(payload),
    data: payload?.data || payload,
  };
}

export async function recordReferralClick(referralCode, platform) {
  if (platform !== "ios" && platform !== "android") return null;

  const response = await fetch(`${BASE_URL}${REFERRALS_CLICK}`, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ referralCode, platform }),
  });

  const contentType = response.headers.get("content-type") || "";
  if (!response.ok || !contentType.includes("application/json")) {
    return null;
  }
  return response.json().catch(() => null);
}
